// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectTree__RKotH .rc-tree-treenode {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 15px;
  position: relative;
}
.selectTree__RKotH .rc-tree-treenode:has(span .rc-tree-indent-unit) {
  background-color: var(--tables-secondary-row-sub-title-surface);
}
.selectTree__RKotH .rc-tree-treenode .rc-tree-indent-unit {
  width: 20px;
}
.selectTree__RKotH .rc-tree-treenode.rc-tree-treenode-selected:not(.rc-tree-treenode-disabled) {
  background-color: var(--tables-primary-row-surface-selected);
}
.selectTree__RKotH .rc-tree-treenode.rc-tree-treenode-selected:not(.rc-tree-treenode-disabled)::before {
  content: "";
  width: 2px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--buttons-surface);
}
.selectTree__RKotH .rc-tree-treenode.rc-tree-treenode-disabled .rc-tree-node-content-wrapper {
  color: var(--selection-controls-checkbox-text-disable);
  cursor: not-allowed !important;
}
.selectTree__RKotH .rc-tree-treenode.filter-node .rc-tree-node-content-wrapper {
  font-weight: 500 !important;
  color: var(--tables-primary-row-text-main) !important;
  position: relative;
}
.selectTree__RKotH .rc-tree-treenode.filter-node .rc-tree-node-content-wrapper::after {
  content: "";
  width: 5px;
  height: 5px;
  position: absolute;
  top: 0;
  right: 0px;
  background-color: var(--buttons-surface);
  border-radius: 50%;
}
.selectTree__RKotH .rc-tree-treenode.filter-node .rc-tree-node-content-wrapper .rc-tree-title {
  position: relative;
}
.selectTree__RKotH .rc-tree-treenode span.rc-tree-checkbox {
  width: 12px !important;
  height: 12px !important;
  position: relative;
  order: 3;
}
.selectTree__RKotH .rc-tree-treenode span.rc-tree-checkbox.rc-tree-checkbox-checked::after {
  content: "";
  opacity: 1;
}
.selectTree__RKotH .rc-tree-treenode span.rc-tree-checkbox.rc-tree-checkbox-disabled {
  border: 1px solid var(--tabs-text-disable) !important;
  background: none;
  cursor: not-allowed !important;
}
.selectTree__RKotH .rc-tree-treenode span.rc-tree-checkbox.rc-tree-checkbox-disabled::after {
  content: "";
  width: 6px;
  height: 6px;
  background-color: var(--tabs-text-disable);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.selectTree__RKotH .rc-tree-treenode .rc-tree-node-content-wrapper {
  font-weight: 500;
  color: var(--tables-primary-row-text-main);
  width: calc(100% - 25px);
  overflow: hidden;
  height: unset;
  display: flex;
}
.selectTree__RKotH .rc-tree-treenode .rc-tree-node-content-wrapper .rc-tree-title {
  width: auto;
  max-width: 95%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.selectTree__RKotH .rc-tree-treenode .rc-tree-node-selected {
  font-weight: 700;
  background-color: unset;
  box-shadow: none;
  opacity: 1;
  pointer-events: none;
}
.selectTree__RKotH .rc-tree-treenode .rc-tree-switcher-noop {
  display: none !important;
}
.selectTree__RKotH .rc-tree-treenode span.rc-tree-switcher {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  background-image: none;
  margin-right: 5px;
}
.selectTree__RKotH .rc-tree-treenode span.rc-tree-switcher:not(.rc-tree-switcher-noop) + .rc-tree-checkbox + .rc-tree-node-content-wrapper {
  width: calc(100% - 47px);
}
.selectTree__RKotH .rc-tree-treenode span.rc-tree-switcher svg path {
  stroke: var(--tables-primary-row-icon) !important;
}
.selectTree__RKotH .rc-tree-list {
  overflow: hidden;
}

.shortVariantSelectTree__wJ1gD .rc-tree-list {
  height: 275px;
  overflow-y: auto;
}

.locationContainer__ozape {
  display: flex;
  flex-direction: column;
}

.facilityName__dmJDQ {
  color: var(--tables-primary-row-text-additional);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/UserModal/components/LocationSelectBlock/style.module.scss"],"names":[],"mappings":"AA4EI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AA3EN;AA6EM;EACE,+DAAA;AA3ER;AA8EM;EACE,WAAA;AA5ER;AA+EM;EACE,4DAAA;AA7ER;AA+EQ;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,wCAAA;AA7EV;AAkFQ;EACE,sDAAA;EACA,8BAAA;AAhFV;AAqFQ;EACE,2BAAA;EACA,qDAAA;EACA,kBAAA;AAnFV;AAqFU;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,wCAAA;EACA,kBAAA;AAnFZ;AAsFU;EACE,kBAAA;AApFZ;AAyFM;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;AAvFR;AA0FU;EACE,WAAA;EACA,UAAA;AAxFZ;AA4FQ;EACE,qDAAA;EACA,gBAAA;EACA,8BAAA;AA1FV;AA4FU;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AA1FZ;AA+FM;EACE,gBAAA;EACA,0CAAA;EACA,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;AA7FR;AA+FQ;EACE,WAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA7FV;AAiGM;EACE,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;AA/FR;AAkGM;EACE,wBAAA;AAhGR;AAmGM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAjGR;AAmGQ;EACE,wBAAA;AAjGV;AAoGQ;EACE,iDAAA;AAlGV;AAsGI;EACE,gBAAA;AApGN;;AA2GI;EACE,aAAA;EACA,gBAAA;AAxGN;;AA6GA;EACE,aAAA;EACA,sBAAA;AA1GF;;AA6GA;EACE,gDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA1GF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.selectTree {\n  :global {\n    .rc-tree-treenode {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 8px 15px;\n      position: relative;\n\n      &:has(span .rc-tree-indent-unit) {\n        background-color: var(--tables-secondary-row-sub-title-surface);\n      }\n\n      .rc-tree-indent-unit {\n        width: 20px;\n      }\n\n      &.rc-tree-treenode-selected:not(.rc-tree-treenode-disabled) {\n        background-color: var(--tables-primary-row-surface-selected);\n\n        &::before {\n          content: '';\n          width: 2px;\n          height: 100%;\n          position: absolute;\n          top: 0;\n          left: 0;\n          background-color: var(--buttons-surface);\n        }\n      }\n\n      &.rc-tree-treenode-disabled {\n        .rc-tree-node-content-wrapper {\n          color: var(--selection-controls-checkbox-text-disable);\n          cursor: not-allowed !important;\n        }\n      }\n\n      &.filter-node {\n        .rc-tree-node-content-wrapper {\n          font-weight: 500 !important;\n          color: var(--tables-primary-row-text-main) !important;\n          position: relative;\n\n          &::after {\n            content: '';\n            width: 5px;\n            height: 5px;\n            position: absolute;\n            top: 0;\n            right: 0px;\n            background-color: var(--buttons-surface);\n            border-radius: 50%;\n          }\n\n          .rc-tree-title {\n            position: relative;\n          }\n        }\n      }\n\n      span.rc-tree-checkbox {\n        width: 12px !important;\n        height: 12px !important;\n        position: relative;\n        order: 3;\n\n        &.rc-tree-checkbox-checked {\n          &::after {\n            content: '';\n            opacity: 1;\n          }\n        }\n\n        &.rc-tree-checkbox-disabled {\n          border: 1px solid var(--tabs-text-disable) !important;\n          background: none;\n          cursor: not-allowed !important;\n\n          &::after {\n            content: '';\n            width: 6px;\n            height: 6px;\n            background-color: var(--tabs-text-disable);\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n          }\n        }\n      }\n\n      .rc-tree-node-content-wrapper {\n        font-weight: 500;\n        color: var(--tables-primary-row-text-main);\n        width: calc(100% - 25px);\n        overflow: hidden;\n        height: unset;\n        display: flex;\n\n        .rc-tree-title {\n          width: auto;\n          max-width: 95%;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n      }\n\n      .rc-tree-node-selected {\n        font-weight: 700;\n        background-color: unset;\n        box-shadow: none;\n        opacity: 1;\n        pointer-events: none;\n      }\n\n      .rc-tree-switcher-noop {\n        display: none !important;\n      }\n\n      span.rc-tree-switcher {\n        width: 24px;\n        height: 24px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-left: auto;\n        background-image: none;\n        margin-right: 5px;\n\n        &:not(.rc-tree-switcher-noop) + .rc-tree-checkbox + .rc-tree-node-content-wrapper {\n          width: calc(100% - 47px);\n        }\n\n        svg path {\n          stroke: var(--tables-primary-row-icon) !important;\n        }\n      }\n    }\n    .rc-tree-list {\n      overflow: hidden;\n    }\n  }\n}\n\n.shortVariantSelectTree {\n  :global {\n    .rc-tree-list {\n      height: 275px;\n      overflow-y: auto;\n    }\n  }\n}\n\n.locationContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.facilityName {\n  color: var(--tables-primary-row-text-additional);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectTree": `selectTree__RKotH`,
	"shortVariantSelectTree": `shortVariantSelectTree__wJ1gD`,
	"locationContainer": `locationContainer__ozape`,
	"facilityName": `facilityName__dmJDQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
